//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },

  methods: {
    handleGuiderClick() {
      this.$router.push('/industry');
    },
  },

  created() {},

  mounted() {},
};



// WEBPACK FOOTER //
// ./src/views/step/success.vue